import { mxgraphInstance } from './mxgraphFactory';
/**
 * View
 */
export var mxCellEditor = mxgraphInstance.mxCellEditor;
export var mxCellOverlay = mxgraphInstance.mxCellOverlay;
export var mxCellRenderer = mxgraphInstance.mxCellRenderer;
export var mxCellState = mxgraphInstance.mxCellState;
export var mxCellStatePreview = mxgraphInstance.mxCellStatePreview;
export var mxConnectionConstraint = mxgraphInstance.mxConnectionConstraint;
export var mxEdgeStyle = mxgraphInstance.mxEdgeStyle;
export var mxGraph = mxgraphInstance.mxGraph;
export var mxGraphSelectionModel = mxgraphInstance.mxGraphSelectionModel;
export var mxGraphView = mxgraphInstance.mxGraphView;
export var mxLayoutManager = mxgraphInstance.mxLayoutManager;
export var mxMultiplicity = mxgraphInstance.mxMultiplicity;
export var mxOutline = mxgraphInstance.mxOutline;
export var mxPerimeter = mxgraphInstance.mxPerimeter;
export var mxPrintPreview = mxgraphInstance.mxPrintPreview;
export var mxStyleRegistry = mxgraphInstance.mxStyleRegistry;
export var mxStylesheet = mxgraphInstance.mxStylesheet;
export var mxSwimlaneManager = mxgraphInstance.mxSwimlaneManager;
export var mxTemporaryCellStates = mxgraphInstance.mxTemporaryCellStates;
// export const renderingHint = mxgraphInstance.renderingHint;
/**
 * mxGraphSelectionModel
 */
// export const mxSelectionChange = mxgraphInstance.mxSelectionChange;
/**
 * mxGraphView
 */
// export const mxCurrentRootChange = mxgraphInstance.mxCurrentRootChange;
//# sourceMappingURL=View.js.map